import {updateUrlOnDateSwitchChange, updateUrlParams} from "../../../utils";
import {useSearchParams} from "react-router";
import {FieldDateSwitch2, FieldDateSwitchValue, FieldSelect} from "../../ui";
import {useEffect, useState} from "react";
import {pageQueryStore} from "../../../store";
import {PicklistFilterLastScanStatus} from "../../../api/fms";

function FmsPicklistFilterbar() {
    const [searchParams, setSearchParams] = useSearchParams()

    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
    const scanStatusS = searchParams.get('scanStatus') || undefined
    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)

    const [scanStatus, setScanStatus] = useState<PicklistFilterLastScanStatus | ''>(scanStatusS as PicklistFilterLastScanStatus || '')

    useEffect(() => {
        const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
        const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
        const scanStatusS = searchParams.get('scanStatus') as PicklistFilterLastScanStatus || ''

        setFrom(fromS ? {
            absolute: searchParams.get('fromAbsolute') || undefined,
            relative: searchParams.get('fromRelative') || undefined,
        } : undefined)
        setTo(toS ? {
            absolute: searchParams.get('toAbsolute') || undefined,
            relative: searchParams.get('toRelative') || undefined,
        } : undefined)
        setScanStatus(scanStatusS)
    }, [
        searchParams,
        setScanStatus,
        setFrom,
        setTo
    ])

    const hasFilter = Boolean(fromS) || Boolean(toS) || Boolean(scanStatusS)

    const lastScanStatusOptions:{
        value: string;
        label: string;
    }[] = []

    if (scanStatus) {
        lastScanStatusOptions.push({
            value: '',
            label: 'Alle'
        })
    }

    lastScanStatusOptions.push(
        {
            value: PicklistFilterLastScanStatus.INCOMPLETE,
            label: 'Offen'
        },
        {
            value: PicklistFilterLastScanStatus.COMPLETE,
            label: 'Abgeschlossen'
        }
    )

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Von"}
                value={from}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                    setFrom(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Bis"}
                value={to}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                    setTo(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldSelect
                label={'Last Scan Status'}
                value={scanStatus || ''}
                onChange={v => {
                    updateUrlParams({
                        val: [{
                            param: 'scanStatus',
                            value: v ? [v] : []
                        }],
                        searchParams,
                        setSearchParams
                    })
                    setScanStatus(v as PicklistFilterLastScanStatus || undefined)
                }}
                options={lastScanStatusOptions}
            />
        </div>
        {<div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    setFrom(undefined)
                    setTo(undefined)
                    Array.from(searchParams.keys()).forEach(key => {
                        searchParams.delete(key)
                    })
                    setSearchParams(searchParams)
                    pageQueryStore.clear('fms-picklist')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>}
    </div>
}

export {
    FmsPicklistFilterbar
}
